import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Rewards } from '@core/models/rewards.model';

@Injectable()
export class TelemarketerRewardsEntityService extends EntityCollectionServiceBase<Rewards> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super('Reward', serviceElementsFactory);
    }
}

